import { Button, Image, Text } from '@change/ds-core-ui/next';

import imageUrl from 'src/assets/ppmu/heart-hands.png';

import { useSlideUpForm } from './hooks/useSlideUpForm';

type Props = Parameters<typeof useSlideUpForm>[0];

export const Variant7: React.FC<Props> = (props) => {
	const {
		data: { localizedAmount, loading, headline },
		actions: { clickAccept, clickDecline, clickAcceptDifferentAmount },
	} = useSlideUpForm(props);

	return (
		<div className="flex w-full flex-col gap-8 px-2 pt-6 md:mx-auto md:w-1/3">
			<Image src={imageUrl} alt="Heart Hands" width={145} height={120} className="aspect-auto" />
			<div className="flex flex-col gap-2">
				<Text variant="heading" size="small">
					{headline}
				</Text>
				<Text variant="body">Monthly support is the best way to keep Change.org free.</Text>
			</div>
			<div className="flex flex-col gap-5">
				<Button onClick={clickAccept} variant="primary" disabled={loading}>
					<Text fontWeight="bold" variant="heading" size="x-small" className="whitespace-normal">
						Yes, I’ll give {localizedAmount} monthly
					</Text>
				</Button>
				<Button onClick={clickAcceptDifferentAmount} variant="secondary" disabled={loading}>
					<Text fontWeight="bold" variant="heading" size="x-small" className="whitespace-normal">
						Yes, I’ll give a different monthly amount
					</Text>
				</Button>

				<Button onClick={clickDecline} variant="tertiary" disabled={loading}>
					<Text fontWeight="bold" variant="heading" size="x-small" className="whitespace-normal">
						No, thanks
					</Text>
				</Button>
			</div>
		</div>
	);
};
